__turbopack_context__.v({
  "fixedBgContent": "fixedBackgroundScroll-module__Bo8Kea__fixedBgContent",
  "fixedBgImageWrap": "fixedBackgroundScroll-module__Bo8Kea__fixedBgImageWrap",
  "fixedBgLayer": "fixedBackgroundScroll-module__Bo8Kea__fixedBgLayer",
  "fixedBgOverlay": "fixedBackgroundScroll-module__Bo8Kea__fixedBgOverlay",
  "fixedBgSectionRoot": "fixedBackgroundScroll-module__Bo8Kea__fixedBgSectionRoot",
  "fixedBgTextStage": "fixedBackgroundScroll-module__Bo8Kea__fixedBgTextStage",
  "fixedBgVhSpacer": "fixedBackgroundScroll-module__Bo8Kea__fixedBgVhSpacer",
  "fixedBgViewportContent": "fixedBackgroundScroll-module__Bo8Kea__fixedBgViewportContent",
});
